var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSvgFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FF9933"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5245 7.46352C19.6741 7.00287 20.3259 7.00287 20.4755 7.46353L23.0309 15.3283C23.0979 15.5343 23.2899 15.6738 23.5065 15.6738H31.776C32.2603 15.6738 32.4617 16.2936 32.0698 16.5783L25.3797 21.439C25.2044 21.5663 25.1311 21.792 25.1981 21.998L27.7535 29.8627C27.9031 30.3234 27.3759 30.7064 26.984 30.4217L20.2939 25.561C20.1186 25.4337 19.8814 25.4337 19.7061 25.5611L13.016 30.4217C12.6241 30.7064 12.0969 30.3234 12.2465 29.8627L14.8019 21.998C14.8689 21.792 14.7956 21.5663 14.6203 21.439L7.93016 16.5783C7.5383 16.2936 7.73969 15.6738 8.22405 15.6738H16.4935C16.7101 15.6738 16.9021 15.5343 16.9691 15.3283L19.5245 7.46352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSvgFilled);
export default __webpack_public_path__ + "static/media/StarSVGFilled.ed736ea0749719650e69cf840fb16f2a.svg";
export { ForwardRef as ReactComponent };